"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = exports.getDatadogLogger = void 0;
const environment_1 = require("./environment");
const browser_logs_1 = require("@datadog/browser-logs");
const filter_1 = require("./filter");
const getDatadogLogger = () => {
    return browser_logs_1.datadogLogs.logger;
};
exports.getDatadogLogger = getDatadogLogger;
const configure = ({ environment, clientPublicToken, appName, appVersion, beforeSend: customBeforeSend, forwardConsoleLogs = "all", }) => {
    browser_logs_1.datadogLogs.init({
        beforeSend: (log) => {
            console.debug("beforeSend log: ", log);
            if (customBeforeSend) {
                console.debug("customBeforeSend");
                customBeforeSend(log);
            }
            (0, filter_1.filterLogBeforeSend)(log);
            return true;
        },
        clientToken: clientPublicToken,
        env: environment,
        forwardConsoleLogs,
        forwardErrorsToLogs: true,
        proxy: (options) => (0, environment_1.proxyFor)(Object.assign(Object.assign({ environment }, options), { path: "logs" })),
        service: appName,
        sessionSampleRate: 100,
        site: environment_1.DATADOG_SITE,
        telemetrySampleRate: 20,
        version: appVersion,
    });
    console.debug = () => { };
    logUncaughtErrors();
};
exports.configure = configure;
const logUncaughtErrors = () => {
    window.onerror = function (_message, _source, _lineno, _colno, error) {
        browser_logs_1.datadogLogs.logger.error((error === null || error === void 0 ? void 0 : error.message) || "", {
            error: { stack: error === null || error === void 0 ? void 0 : error.stack },
        }, error);
    };
};
//# sourceMappingURL=logging.js.map